import cx from 'classnames';
import * as React from 'react';

export interface TombacIconProps extends React.SVGProps<SVGSVGElement> {
  fixedWidth?: boolean;
  flip?: false | 'horizontal' | 'vertical';
  rotate?: 0 | 90 | 180 | 270;
  size?: 'xs' | 'sm' | 'lg' | 1 | 2 | 3 | 5 | 7 | 10;
  spin?: boolean;
}

const tombacIcon = (name: string) => {
  const nameWords = name.match(
    /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g,
  );

  const kebabCasedName = nameWords
    ? nameWords.join('-').toLowerCase()
    : name.toLowerCase();

  return (SvgIcon: React.ComponentType<React.SVGProps<SVGSVGElement>>) => {
    const TombacIcon = ({
      className,
      fixedWidth = true,
      flip = false,
      rotate = 0,
      size = 1,
      spin = false,
      ...rest
    }: TombacIconProps) => {
      return (
        <SvgIcon
          className={cx(
            'TombacIcon',
            `TombacIcon--${kebabCasedName}`,
            fixedWidth && 'TombacIcon--fixed-width',
            flip && `TombacIcon--flip-${flip}`,
            rotate !== 0 && `TombacIcon--rotate-${rotate}`,
            size !== 1 &&
              `TombacIcon--${typeof size === 'string' ? size : size + 'x'}`,
            spin && `TombacIcon--spin`,
            className,
          )}
          {...rest}
        />
      );
    };

    TombacIcon.displayName = `${name}Icon`;

    return TombacIcon;
  };
};

export default tombacIcon;
